import { SvgIcon, type SvgIconProps } from '@mui/material';

export function TwitterXIcon(props: SvgIconProps) {
  return (
    <SvgIcon color="inherit" {...props}>
      <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
        <title>X Twitter</title>
        <path
          fill="currentColor"
          d="M128.576 128l290.368 435.488L138.752 896h83.68l233.44-276.992L640.576 896h255.936L598.816 449.376 869.632 128h-83.68L561.888 393.952 384.576 128h-256zm119.616 64h102.112l426.624 640H674.816L248.192 192z"
        />
      </svg>
    </SvgIcon>
  );
}
